<p class="italic">
  Murano Fantasy is an NFT piece of art made by artist Pandelune and is currently on sale on <a href="https://www.artblocks.io/project/193">artblocks.io</a>.
</p>
